import React, { useState } from "react";
import { collection, doc, setDoc } from "firebase/firestore";
// import { useHistory } from 'react-router';
import { auth } from "./firebaseConfig";
import { signOut } from "firebase/auth";
import { Link } from "react-router-dom";
import { database, StorageFolder } from "./firebaseConfig";
import {
  Box,
  Center,
  ChakraProvider,
  VStack,
  Stack,
  Heading,
  useMediaQuery,
} from "@chakra-ui/react";

// import { useAuthContext } from './authContext';
import Navbar from "./NavBar";
import EditFormMenu from "./EditFormMenu";
import Logo from "./Logo";
import EditFloraTable from "./EditFloraTable";
import { useLanguage } from "./languageContext";

const EditFloraPage = () => {
  const [isSmallScreen] = useMediaQuery("(max-width: 1100px)");
  const { language, toggleLanguage } = useLanguage();

  return (
    <ChakraProvider>
      <Box
        backgroundImage={"url(bird.jpeg)"}
        backgroundSize="cover"
        // backdropFilter="auto"
        // backdropBlur={"5px"}
      >
        <Navbar />
        <VStack spacing={4} align="stretch">
          <Center >
            <Stack align="center">
              <Box
                p={4}
                pt={"10%"}
                width={{ base: "80%", md: "80%" }}
                maxW="1100px"
                minH="100vh"
              >
                <Box p={8} bg="white" rounded="md" shadow="md" width="100%">
                  <Center bg="#f8f8f8">
                    <Box textAlign="center">
                      <EditFormMenu isSmallScreen={isSmallScreen} />
                    </Box>
                  </Center>

                  <Logo isSmallScreen={isSmallScreen} />

                  <Box textAlign="center">
                    <Heading fontSize={{ base: "xl", md: "2xl", lg: "3xl" }}>
                      {language === "english"
                        ? "Edit Flora Data"
                        : "Editar Datos de Flora"}{" "}
                    </Heading>
                  </Box>
                  <EditFloraTable />
                </Box>
              </Box>
            </Stack>
          </Center>
        </VStack>
      </Box>
    </ChakraProvider>
  );
};

export default EditFloraPage;
